import { IAgentPromptLogReference } from './agentPromptLog';

export interface IAgentQACreate {
  name: string;
  agent_type: string;
  dialect_id: number;
  number_of_runs: number;
  courses?: number[];
  bank_ids?: number[];
}

export interface ITranslationBank {
  id: number;
  name: string;
  agent_type: string;
  item_count: number;
  created_at: string;
}

export interface IAgentQAListItem {
  id: number;
  name: string;
  agent_type: string;
  status: number;
  priority?: number;
  number_of_runs: number;
  created_at: string;
  items_count: number;
  progress: {
    total: number;
    completed: number;
    pass: number;
    fail: number;
    percentage: number;
  };
}

export interface IAgentQAEdit {
  id: number;
  name: string;
  agent_type: string;
  status: number;
  priority?: number;
  number_of_runs: number;
  created_at: string;
  items_count: number;
  progress: {
    total: number;
    completed: number;
    pass: number;
    fail: number;
    percentage: number;
  };
}

export interface IAgentQAItem {
  id: number;
  run_number: number;
  status: number;
  test_result: 'pass' | 'fail' | null;
  expected_result: any;
  actual_result: any;
  test_metadata: {
    match_score?: number;
    reasoning?: string;
  } | null;
  async_task_status: number;
  navigation_data?: any;
  item_info?: {
    entity_id?: number;
    ref?: number;
    translation_id?: number | null;
    us_translation: string;
    target_translation: string;
    dialect_code: string;
    agent_type: string;
  };
  /**
   * Reference to the agent prompt log.
   * Optional because:
   * - Items created before logging was implemented won't have this
   * - Pending items that haven't been processed yet won't have logs
   * - Some items may not use agents (manual entries)
   */
  agent_prompt_log?: IAgentPromptLogReference;
}

export const AgentQAJobStatus = {
  PENDING: 0,
  RUNNING: 1,
  DONE: 2,
} as const;

export const AgentQAItemStatus = {
  PENDING: 0,
  PROCESSING: 1,
  DONE: 2,
  ERROR: 3,
} as const;

export interface IAgentQARunResult {
  id: number;
  run_number: number;
  status: number;
  test_result: 'pass' | 'fail' | null;
  actual_result: any;
  expected_result: any;
  test_metadata: IAgentQAItem['test_metadata'];
  async_task_status: number;
  agent_prompt_log?: IAgentQAItem['agent_prompt_log'];
}

export interface IAgentQAGroupedItem {
  id: number;
  entity_key: string;
  item_info: IAgentQAItem['item_info'];
  navigation_data?: any;
  runs: IAgentQARunResult[];
  pass_count: number;
  fail_count: number;
  pending_count: number;
  error_count: number;
  async_task_status: number;
  agent_prompt_log?: IAgentPromptLogReference;
}
